// extracted by mini-css-extract-plugin
export var cont = "index-module--cont--6550a index-module--cont--caa8c container mx-auto px-4";
export var headerContainer = "index-module--headerContainer--45b03 py-1 lg_py-4";
export var headerMessage = "index-module--headerMessage--d3804 py-2 lg_py-4 text-center bg-green";
export var lightRoot = "index-module--lightRoot--1e2e0 text-white";
export var root = "index-module--root--a8f8f fixed z-20 w-full left-0 top-0 primary-anime";
export var row = "index-module--row--e4bd0 flex items-center";
export var withBG = "index-module--withBG--905b3 text-white bg-black";